<template>
  <div class="vx-row">
    <div class="vx-col md:w-2/3 w-full">
      <vx-card class="mb-4">
        <marquee-text class="pl-24" :repeat="20" :duration="50">
          <h3>{{notice}}</h3>
        </marquee-text>
      </vx-card>
      <vx-card>
        <div class="vx-row">
          <div class="vx-col md:w-1/3 w-full">
            <h4>จัดการบริหารรอบใบเสร็จ</h4>
          </div>
        </div>
        <div class="vx-row mt-4">
          <div class="vx-col w-full text-right">
            <!-- <ExcelP17PrapaExport @button-clicked="updateP17BooleanValue"/> -->
            <!-- <ExcelP17PrapaAllDebtByAreaReport :billConfig="billIdNow.billId" :org="org" @button-clicked="updateBooleanValue"/> -->
           </div>
        </div>
        <div class="vx-row mt-2">
          <div class="vx-col w-full text-right">
           <vs-button v-if="position !== 'แผนก IT'" @click="submitChangeBill" :disabled="disableBtn" class="mb-2">เปลี่ยนรอบบิล</vs-button>
            <vs-button v-if="position === 'แผนก IT'" @click="changeBillConfig" class="mb-2">เปลี่ยนรอบบิล</vs-button></div>
        </div>
        <div class="vx-row my-5">
          <div class="vx-col md:w-1/4 w-full text-right ">
            รหัสรอบบิลปัจจุบัน:
          </div>
          <div class="vx-col md:w-2/4">
            <vs-input class="input-bill" v-model="billIdNow.billId" readonly/>
          </div>
          <div class="vx-col md:w-1/4 w-full">
            {{billIdNow.name}}
          </div>
        </div>
        <div v-if="position !== 'แผนก IT'" class="vx-row my-5">
          <div class="vx-col md:w-1/4 w-full text-right ">
            บันทึกเลขที่ใบเสร็จแล้ว:
          </div>
          <div class="vx-col md:w-2/4">
            <vs-input class="input-bill" v-model="billIdNow.meter" readonly/>
          </div>
        </div>
        <div v-if="position === 'แผนก IT'" class="vx-row my-5">
          <div class="vx-col md:w-1/4 w-full text-right ">
            บันทึกมิเตอร์แล้ว:
          </div>
          <div class="vx-col md:w-2/4">
            <vs-input class="input-bill" v-model="billIdNow.meter"/>
          </div>
        </div>
        <div v-if="position !== 'แผนก IT'" class="vx-row my-5">
          <div class="vx-col md:w-1/4 w-full text-right ">
            จำนวนผู้ใช้จริง:
          </div>
          <div class="vx-col md:w-2/4">
            <vs-input class="input-bill" v-model="billIdNow.user" readonly/>
          </div>
        </div>
        <div v-if="position === 'แผนก IT'" class="vx-row my-5">
          <div class="vx-col md:w-1/4 w-full text-right ">
            จำนวนผู้ใช้จริง:
          </div>
          <div class="vx-col md:w-2/4">
            <vs-input class="input-bill" v-model="billIdNow.user"/>
          </div>
        </div>
        <div class="vx-row my-5">
          <div class="vx-col md:w-1/4 w-full text-right ">
            รอบบิลต่อไป:
          </div>
          <div class="vx-col md:w-2/4">
            <vs-input class="input-bill" v-model="billIdNext.billId" readonly/>
          </div>
        </div>
        <div class="vx-row my-5" v-if="check">
          <div class="vx-col sm:w-1/1 w-full">
            <span class="text-red align-text-bottom">*</span>
            <span class="text-red">จำนวนผู้ชำระค่าขยะจริงจะแสดง เมื่อจดมิเตอร์คนแรก</span>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="vx-col md:w-1/3 w-full">
      <vx-card title="รอบบิลต่อไป">
        <div class="vx-row mb-4">
          <div class="vx-col md:w-2/5 w-full text-right">
            ลำดับที่:
          </div>
          <div class="vx-col md:w-3/5 w-full">
            {{billIdNext.no}}
          </div>
        </div>
        <div class="vx-row my-4">
          <div class="vx-col md:w-2/5 w-full text-right">
            รหัสรอบบิล:
          </div>
          <div class="vx-col md:w-3/5 w-full">
            {{billIdNext.billId}}
          </div>
        </div>
        <div class="vx-row my-4">
          <div class="vx-col md:w-2/5 w-full text-right">
            ชื่อรอบบิล:
          </div>
          <div class="vx-col  md:w-3/5 w-full">
            {{billIdNext.name}}
          </div>
        </div>
        <div class="vx-row my-4">
          <div class="vx-col md:w-2/5 w-full text-right">
            ปีงบประมาณ:
          </div>
          <div class="vx-col md:w-3/5 w-full">
            {{billIdNext.year}}
          </div>
        </div>
<!--        <div class="vx-row my-4">-->
<!--          <div class="vx-col md:w-2/5 w-full text-right">-->
<!--            สถานะรอบ:-->
<!--          </div>-->
<!--          <div class="vx-col md:w-3/5 w-full">-->
<!--            {{bill.next.CB05}}-->
<!--          </div>-->
<!--        </div>-->
      </vx-card>
    </div>
  </div>
</template>
<script>
  import moduleBillConfig from "@/store/billconfig/moduleBillConfig.js";
  import ExcelP17PrapaExport from "../pdf/ExcelP17PrapaExport.vue";
  import ExcelP17PrapaAllDebtByAreaReport from "../pdf/ExcelP17PrapaAllDebtByAreaReport.vue";
  import moduleConfig from "@/store/config/moduleConfig.js";
  export default {
    components: {
      ExcelP17PrapaAllDebtByAreaReport,
      ExcelP17PrapaExport
    },
    computed:{
      org() {
        return this.$store.state.config.item;
      },
    },
    data() {
      return {
        bill: {},
        disableBtn: true,
        isBackup: true,
        isP17Backup: true,
        check: true,
        billId: '',
        position: '',
        billIdNext: {
          no: '',
          billId: '',
          name: '',
          year: ''
        },
        billIdNow: {
          billId: '',
          meter: '',
          user: '',
          name: ''
        },
        notice:'***ให้กำหนดเปลี่ยนรอบบิลเดือนละ 1 ครั้ง หากจำนวนที่บันทึกมิเตอร์แล้วกับจำนวนผู้ชำระค่าขยะจริงไม่เท่ากัน กรุณาตรวจสอบ รายชื่อผู้ชำระค่าขยะที่แอปบนมือถือ เมนูจดมิเตอร์ทุกเส้นทางว่ายังมีรายชื่อค้างอยู่หรือไม่ ถ้าไม่มีแล้วให้ติดต่อผู้ดูแล***'
      }
    },
    watch: {
      bill(val) {
        if ((val.bookListCount == val.current.CB06)) {
          if((val.bookListCount === 0 || val.bookListCount === '0') && (val.current.CB06 === 0 || val.current.CB06 === '0')) {
            this.disableBtn = true;
          } else {
            this.disableBtn = false;
          }
        } else {
          this.disableBtn = true;
        }
      }
    },
    methods: {
     async init() {
        const bill = await this.$store.state.billConfigs.item;
        this.bill = await this.$store.state.billConfigs.item;
        this.billIdNext = {
          no: bill.next.CB02,
          billId:  bill.next.CB01,
          name:  bill.next.CB04,
          year:  bill.next.CB03
        };
        this.billIdNow = {
          billId: bill.current.CB01,
          meter: bill.bookListCount,
          user: bill.current.CB06,
          name:  bill.current.CB04
        };
        this.$vs.loading.close()
      },
      submitChangeBill() {
        this.$vs.dialog({
          type: 'confirm',
          title: `กำหนดรอบบิล`,
          text: 'ต้องการเปลี่ยนรอบบิลใช่หรือไม่',
          accept: this.confirmChangeBill,
          acceptText: 'ตกลง',
          cancelText: 'ยกเลิก'
        })
      },
      async changeBillConfig() {
        this.disableBtn = true
        this.$vs.loading();
        await this.$store.dispatch("billConfigs/updateData").then((res) => {
          if (res.data.status) {
            this.init();
          } else {
            this.$vs.loading.close()
          }
        }).catch(error => {
          this.$vs.loading.close()
        });
      },
      confirmChangeBill() {
        this.$vs.dialog({
          type: 'alert',
          title: `ข้อกำหนดการใช้งานโปรแกรม`,
          text: 'แจ้งเพื่อทราบ​  โปรแกรมขยะ​ On​  Mobile​ออกแบบมาเพื่อใหัการทำงานของเจ้าหน้าที่สะดวกขึ้นและเพื่อป้องกันการทุจริต​  ถ้าทางเราตรวจพบเจ้าหน้าที่ไม่ ทำตามขั้นตอนในคู่มือที่ได้อบรมไป​   โดยไม่ พิมพ์ รายงานป.32 ประจำวันออกจากโปรแกรมหน้าเว็บ และไม่พิมพ์ใบเสร็จตัวจริงสีเขียว ตามป.32 ประจำวัน ไม่บันทึกเลขที่ใบเสร็จ เพื่อให้พิมพ์ในป. 32 ประจำวัน และไม่ฉีกต้นขั้ว ใบเสร็จสีเขียวไว้ให้สตง.ตรวจภายหลัง ทางเราจะ ระงับการใช้งานโปรแกรมชั่วคราวโดยไม่จำเป็นต้องแจ้งให้ทราบก่อนล่วงหน้า​ และ ผอ.กองคลัง จะต้องกำหนด User ที่เข้าใช้งานและเข้าตรวจสอบ การส่งเงิน ให้มีรหัสของใครของคนนั้น และจะต้องมี User ที่เป็น เจ้าหน้าที่ที่เป็นข้าราชการ เพื่อจะได้เข้าไปตรวจสอบการทำงานได้ เพื่อเป็นการป้องกันการทุจริต หากเกิดความไม่สะดวกต้องขออภัยมาณ.ที่นี้ด้วยครับ หากมีปัญหาขัดข้องประการใด ให้เป็นเพื่อนทางไลน์​ OA​ และติดต่อ ส่งข้อความ มาทางไลน์ เท่านั้นครับ',
          accept: this.changeBillConfig,
          acceptText: 'รับทราบ'
        })
      },
    },
    async created() {
      const user = JSON.parse(sessionStorage.getItem('vuex'));
      this.position = user.owner.user.user.positionname;
      this.$vs.loading();
      if (!moduleBillConfig.isRegistered) {
        this.$store.registerModule('billConfigs', moduleBillConfig);
        moduleBillConfig.isRegistered = true;
      }
      if (!moduleConfig.isRegistered) {
        this.$store.registerModule('config', moduleConfig)
        moduleConfig.isRegistered = true
      }
      await this.$store.dispatch("config/fetchDataItem");
      await this.$store.dispatch("billConfigs/fetchDataItem")
      this.init();
    }
  }
</script>
<style lang="scss">
  .input-bill {
    width: 260px;
  }
</style>
